import { Alert } from "@mui/material";

const DisclaimerAlert = ({ message }) => {
  return (
    <Alert severity="info" sx={{ mb: 3, fontFamily: "Poppins, sans-serif" }}>
      {message}
    </Alert>
  );
};

export default DisclaimerAlert;
